import { PatientsService } from "./../patients.service";
import { UntypedFormGroup, UntypedFormBuilder } from "@angular/forms";
import { AppointmentsService } from "./../appointments.service";
import { DatePipe } from "@angular/common";
import { LoginService } from "../login.service";
import { Subject, Subscription, merge } from "rxjs";
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from "@angular/core";
import { SettingsService } from "../settings.service";
import { Router } from "@angular/router";
import moment from "moment";
import { HttpClient } from "@angular/common/http";
import { LanguageService } from "../language.service";
import { TranslateService } from "@ngx-translate/core";
import { FinancialService } from "../financial.service";

@Component({
    selector: "app-appointment",
    templateUrl: "./appointment.component.html",
    styleUrls: ["./appointment.component.scss"],
    standalone: false
})
export class AppointmentComponent implements OnInit, OnDestroy {
  @Output() closed = new EventEmitter();
  @Input("event") event;
  @Input("slotDuration") slotDuration: string;
  @Input("resourceId") resourceId: number;
  @Input("isMultiSelect") isMultiSelect: boolean = false;
  @Output() viewCalendar = new EventEmitter<any>();

  startOptionalsHours = [];
  appointmentForm: UntypedFormGroup;
  showDeleteAlert = false;
  errorUpdate;
  examsTypes = [];
  customExamTypes = [];
  examTypeSubscription: Subscription;
  setExtraDetails = false;
  calculatedPrice;
  lmpError = false;
  allAppointmentsType = [];
  appointmentsByRooms = false;
  fetusSub = new Subscription();
  fundingSub = new Subscription();
  appointmentDateSub = new Subscription();
  payerSub = new Subscription();
  priceSub = new Subscription();
  priceManualSub = new Subscription();
  priceAutoFilled = false;
  priceLookupSeq = 0;
  private readonly payerAliases: { [key: string]: string } = {
    Maccabi: "Macabi",
    "כללית": "Clalit",
    "מכבי": "Macabi",
    "לאומית": "Leumit",
    "מאוחדת": "Meuhedet",
    "פרטי": "Private",
  };
  customColors = [
    "#00FF01", // Green
    "#FF0000", // Red
    "#00A0FF", // Blue
    "#FFFF00", // Yellow
    "#FFC0CB", // Pink
    "#FFBD43", // Orange
    "#FF00FE", // Purple
    "#00FFFF", // Cyan
    "#FF8080",
    "#c5c1c1", // Gray
  ];
  selectedColor: string | null = null;
  dropdownOpen = false;
  previousAppointments = [];
  dateChangesCounts: { [key: number]: number } = {};
  allChanges: number[] = [];
  totalChanges: number = 0;
  totalAppointments: number = 0;
  confirmedArrivals: number = 0;
  canceledArrivals: number = 0;
  noShowAfterConfirmation: number = 0;
  pageDirection: string = "ltr";

  error = "";
  sent = false;
  smsDisabled = false;
  creatingPending = false;
  smsPending = false;
  askSendSMS: boolean;
  sendUpdateSMS: boolean = false;
  scheduleSmsPending = false;
  scheduleSmsError = "";
  scheduleSmsSent = false;

  timeSingleOrTwin: string = "";
  showApptLengthError: boolean = false;
  apptLengthErrorMsg: string = "";

  getDayOfWeek(date: any): string {
    if (!date) return '';
    return moment(date).locale(this.translate.currentLang).format('dddd');
  }
  constructor(
    public appointmentService: AppointmentsService,
    private fb: UntypedFormBuilder,
    private datePipe: DatePipe,
    public patientService: PatientsService,
    public ls: LoginService,
    public settings: SettingsService,
    private router: Router,
    private http: HttpClient,
    public languageService: LanguageService,
    public translate: TranslateService,
    private financialService: FinancialService
  ) {}

  get payers(): string[] {
    return this.financialService.payers;
  }

  get payerMapping() {
    return this.financialService.payerMapping;
  }

  ngOnInit() {
    this.pageDirection = this.languageService.getPageDirection();
    this.settings.getExams().then((data) => {
      this.allAppointmentsType = data;
      const userId = !this.appointmentsByRooms
        ? Number(this.appointmentForm.get("UID").value)
        : Number(this.appointmentForm.get("RID").value);
      const awebExams = data.filter((exam) => {
        return exam["users"].includes(Number(userId)) && !exam.custom;
      });
      this.examsTypes = [...this.examsTypes, ...awebExams];
      this.examsTypes = this.examsTypes.sort((a, b) => {
        if (a.displayOrder !== null && b.displayOrder !== null) {
          return a.displayOrder - b.displayOrder;
        }
        return 0;
      });

      const customExams = data.filter((exam) => {
        return exam["users"].includes(Number(userId)) && exam.custom;
      });
      this.customExamTypes = [...this.customExamTypes, ...customExams];
      this.customExamTypes = this.customExamTypes.sort((a, b) => {
        if (a.displayOrder !== null && b.displayOrder !== null) {
          return a.displayOrder - b.displayOrder;
        }
        return 0;
      });

      if (this.event || this.appointmentService.examType) {
        this.checkAppointmentType();
      }
      if (this.event?.examCode) {
        this.appointmentForm.get("examCode").setValue(this.event.examCode, { emitEvent: false });
      }
      this.refreshExamCodes();
    });

    this.appointmentsByRooms = this.ls?.premissions?.ApptsByRoom;
    this.resetAppointmentsForm();
    this.loadAppointmentsForm();

    this.updateSmsDisabled();

    this.appointmentForm.get("appointmentDate")?.valueChanges.subscribe(() => this.updateSmsDisabled());
    this.appointmentForm.get("startHour")?.valueChanges.subscribe(() => this.updateSmsDisabled());

    this.appointmentForm.get("completed").valueChanges.subscribe((value) => {
      if (value === true) {
        this.appointmentForm.get("surveyFormSMS").setValue(true);
        this.appointmentForm.get("patientArrived").setValue(true);
        this.appointmentForm.get("patientNoArrivalReason").setValue("");
        this.appointmentForm.get("noExamReason").setValue("");
      }
    });

    this.appointmentForm.get("patientArrived").valueChanges.subscribe((value) => {
      if (value === false) {
        this.appointmentForm.get("completed").setValue(null);
        this.appointmentForm.get("patientNoArrivalReason").setValue("");
        this.appointmentForm.get("noExamReason").setValue("");
      }
    });
    this.getPatAppointments();
  }

  closeAppointmentModal(saveAppointment) {
    this.appointmentService.appointmentToNavBack=null;
    this.closed.emit(saveAppointment);
  }

  loadAppointmentsForm() {
    const patient = this.patientService.getPat();

    this.initialStartAppointmentHour();
    this.appointmentForm.get("duration").setValue(this.appointmentService.duration);
    this.appointmentForm.get("appointmentDate").setValue(this.appointmentService.startDate);
    this.appointmentForm.get("patientName").setValue(`${patient.First} ${patient.Last}`);

    const patientMobile = patient.Mobile
      ? String(patient.Mobile)
      : patient.Phone
      ? String(patient.Phone)
      : null;
    this.appointmentForm.get("patientMobile").setValue(patientMobile);

    this.appointmentForm.get("ID").setValue(`${patient.ID}`);
    this.appointmentForm.get("SmsConsent").setValue(patient.SmsConsent);
    this.appointmentForm.get("PID").setValue(patient.PID);

    // Disable SMS features if patient declined consent (false = declined)
    const smsConsent = Boolean(patient.SmsConsent);
    if (smsConsent === false) {
      this.appointmentForm.get("SendSMS").setValue(false);
      this.appointmentForm.get("SendSMS").disable();
      this.appointmentForm.get("ScheduleSMS").setValue(false);
      this.appointmentForm.get("ScheduleSMS").disable();
      this.appointmentForm.get("surveyFormSMS").setValue(false);
      this.appointmentForm.get("surveyFormSMS").disable();    } else {
      this.appointmentForm.get("SendSMS").enable();
      this.appointmentForm.get("ScheduleSMS").enable();
      this.appointmentForm.get("surveyFormSMS").enable();    }

    if (this.appointmentsByRooms) {
      this.appointmentForm.get("RID").setValue(this.isMultiSelect ? this.resourceId : this.ls.room);
    } else {
      this.appointmentForm.get("UID").setValue(this.isMultiSelect ? this.resourceId : this.ls.doctor);
    }

    if (this.event) {
      this.appointmentForm.get("examTypeID").setValue(this.event.examTypeID, { emitEvent: false });
      this.appointmentForm.get("AutoIndex").setValue(this.appointmentService.AutoIndex);
      this.appointmentForm.get("UID").setValue(this.event.DocUID);
      this.appointmentForm.get("RID").setValue(this.event.RID);
      this.appointmentForm.get("SendSMS").setValue(this.event.SendSMS);
      this.appointmentForm.get("ScheduleSMS").setValue(this.event.ScheduleSMS);
      this.appointmentForm.get("completed").setValue(this.event.completed);
      if (this.event.completed === true) {
        this.appointmentForm.get("surveyFormSMS").setValue(true);
      }
      this.appointmentForm.get("comment").setValue(this.event.comment);
      this.appointmentForm.get("customColor").setValue(this.event.customColor);
      this.appointmentForm.get("arrivalConfirm").setValue(this.event.arrivalConfirm);
      this.appointmentForm.get("surveyFormSMS").setValue(this.event.surveyFormSMS);
      this.selectedColor = this.event.customColor;
      if (this.event.LMP) {
        this.appointmentForm.get("LMP").setValue(new Date(this.event.LMP));
      }
      this.appointmentForm.get("Fetus").setValue(this.event.Fetus, { emitEvent: false });
      this.appointmentForm.get("Funding").setValue(this.event.Funding);
      this.appointmentForm.get("Price").setValue(this.event.Price);
      this.appointmentForm.get("Payer")?.setValue(this.event.Payer ?? null, { emitEvent: false });
      this.appointmentForm.get("FundingDetails").setValue(this.event.FundingDetails);
      this.appointmentForm.get("SmsConsent").setValue(this.event.SmsConsent);
      
      // Disable SMS features if patient declined consent (false = declined)
      if (this.event.SmsConsent === false) {
        this.appointmentForm.get("SendSMS").setValue(false);
        this.appointmentForm.get("SendSMS").disable();
        this.appointmentForm.get("ScheduleSMS").setValue(false);
        this.appointmentForm.get("ScheduleSMS").disable();
        this.appointmentForm.get("surveyFormSMS").setValue(false);
        this.appointmentForm.get("surveyFormSMS").disable();
      } else {
        this.appointmentForm.get("SendSMS").enable();
        this.appointmentForm.get("ScheduleSMS").enable();
        this.appointmentForm.get("surveyFormSMS").enable();
      }
      
      if (this.event.examTypeDeleted) this.addDeletedExam();
      this.appointmentForm.get("patientArrived").setValue(this.event.patientArrived);
      this.appointmentForm.get("patientNoArrivalReason").setValue(this.event.patientNoArrivalReason);
      this.appointmentForm.get("noExamReason").setValue(this.event.noExamReason);
      this.appointmentForm.get("examCode").setValue(this.event.examCode ?? null, { emitEvent: false });
      this.refreshExamCodes();
    }

    if (!this.event) {
      if (!this.ls.premissions || !this.ls.premissions.hmoAppointments) {
        this.appointmentForm.get("Funding").setValue("Private");
      }
      if (this.appointmentService.lmp) {
        const lmpWithAddedHours = this.appointmentService.lmp.add(6, "hours");
        this.appointmentForm.get("LMP").setValue(lmpWithAddedHours);
      }

      if (!this.appointmentService.lmp) {
        const lmp = patient.LMP;
        this.appointmentForm.get("LMP").setValue(lmp);
      }

      if (this.appointmentService.examType) {
        this.appointmentForm
          .get("examTypeID")
          .setValue(this.appointmentService.examType, { emitEvent: false });
      }

      if (this.appointmentService.examLength) {
        this.appointmentForm
          .get("duration")
          .setValue(this.appointmentService.examLength, { emitEvent: false });
      }
    }

    this.setupPayerPricing();

    this.fetusSub = this.appointmentForm
      .get("Fetus")
      .valueChanges.pipe()
      .subscribe((fetus) => {
        const durationControl = this.appointmentForm.get("duration");
        const examControl = this.appointmentForm.get("examTypeID");
        if (!examControl.value) return;
        const exam = this.getExam();

        if (fetus == "2" && exam.LengthTwins) {
          durationControl.setValue(exam.LengthTwins);
        } else {
          if (!exam.Length) return;
          durationControl.setValue(exam.Length);
        }
      });

    // this.fundingSub=this.appointmentForm.get('Funding').valueChanges.pipe().subscribe((funding)=>{
    //  if(funding=='Hmo'){
    //   this.getHmoBalance()
    //  }
    //  else{
    //   this.hmoBalance=undefined
    //  }
    // })
    // this.appointmentDateSub=this.appointmentForm.get('appointmentDate').valueChanges.pipe().subscribe((appointmentDate)=>{
    //   if(this.appointmentForm.get('Funding').value=='Hmo'){
    //    this.getHmoBalance()
    //   }
    //   else{
    //    this.hmoBalance=undefined
    //   }
    //  })

    if (!this.event) {
      //this.findClosestAppointment(); //--diabling to use the mouse time to 5min
    }
  }

  private normalizePayer(value: any): string | null {
    if (!value) return null;
    const raw = String(value).trim();
    const key = this.payerAliases[raw] || raw;
    return this.payers.includes(key) ? key : null;
  }

  private setupPayerPricing(): void {
    const payerControl = this.appointmentForm.get("Payer");
    if (!payerControl || !this.ls.premissions?.PayerPricing) return;
    this.payerSub.unsubscribe();
    this.priceSub.unsubscribe();
    this.priceManualSub.unsubscribe();
    this.priceAutoFilled = false;

    this.payerSub = payerControl.valueChanges.subscribe((payer) => {
      if (!payer) return;
      this.appointmentForm.get("Funding").setValue(payer === "Private" ? "Private" : "Hmo");
    });

    this.priceManualSub = this.appointmentForm
      .get("Price")
      .valueChanges.subscribe(() => (this.priceAutoFilled = false));

    this.priceSub = merge(
      payerControl.valueChanges,
      this.appointmentForm.get("examTypeID").valueChanges,
      this.appointmentForm.get("UID").valueChanges
    ).subscribe(() => this.lookupPayerPrice());

    if (!this.event) {
      const payer = this.normalizePayer(this.patientService.currentPatient?.HMO);
      if (payer) {
        payerControl.setValue(payer);
      } else {
        this.lookupPayerPrice();
      }
    }
  }

  private async lookupPayerPrice(): Promise<void> {
    if (this.appointmentsByRooms) return;
    const payer = this.appointmentForm.get("Payer")?.value;
    const examTypeID = Number(this.appointmentForm.get("examTypeID").value);
    const UID = Number(this.appointmentForm.get("UID").value);
    if (!payer || !examTypeID || !UID) return;
    const seq = ++this.priceLookupSeq;
    try {
      const result = await this.financialService.getDoctorPrice(UID, examTypeID, payer);
      if (seq !== this.priceLookupSeq || !result?.found || result.price === null) return;
      const priceControl = this.appointmentForm.get("Price");
      const current = priceControl.value;
      const empty = current === null || current === undefined || current === "";
      if (empty || this.priceAutoFilled) {
        priceControl.setValue(result.price, { emitEvent: false });
        this.priceAutoFilled = true;
      }
    } catch (e) {}
  }

  onDoctorChange(event: Event): void {
    this.ls.doctor = this.appointmentForm.get("UID").value;
    this.closed.emit(this.event);
  }

  onRoomChange(event: Event): void {
    this.ls.room = this.appointmentForm.get("RID").value;
    this.closed.emit(this.event);
  }

  onDateChange(event: Event): void {
    this.ls.room = this.appointmentForm.get("RID").value;
    this.closed.emit(this.event);
    this.viewCalendar.emit(this.event);
  }

  getDoctors() {
    return this.ls.clinicUsers;
  }

  checkAppointmentType() {
    if (this.event) {
      if (this.event.custom) {
        this.appointmentForm.get("custom").setValue(1);
        return;
      }
      this.appointmentForm.get("custom").setValue(0);
    } else if (this.appointmentService.examType) {
      const awebType = this.examsTypes.find(
        (exam) => exam.AutoIndex == this.appointmentService.examType
      );
      if (awebType) {
        this.appointmentForm.get("custom").setValue(0);
        return;
      }
      this.appointmentForm.get("custom").setValue(1);
    }
  }

  initialStartAppointmentHour() {
    const startDate = this.appointmentService.startDate;
    if (startDate) {
      const hours = startDate.getHours().toString().padStart(2, "0");
      const minutes = startDate.getMinutes();
      const startHour = `${hours}:${minutes.toString().padStart(2, "0")}`;
      this.appointmentForm.get("startHour").setValue(startHour);
    }
  }

  resetAppointmentsForm() {
    this.appointmentForm = this.fb.group({
      AutoIndex: [""],
      appointmentDate: [""],
      startHour: [""],
      patientName: [{ value: "", disabled: true }],
      patientMobile: [{ value: null, disabled: true }],
      ID: [{ value: null, disabled: true }],
      examTypeID: [null, { emitEvent: false }],
      duration: [""],
      comment: [null],
      PID: [""],
      UID: [""],
      SendSMS: [this.ls.premissions.SendSMSOnSave ? true : false],
      ScheduleSMS: [this.ls.premissions.SMSReminders ? true : false],
      Funding: ["Hmo"],
      Price: [null],
      LMP: [null],
      Fetus: [null],
      custom: [0],
      FundingDetails: [null],
      RID: [""],
      completed: [null],
      customColor: [null],
      arrivalConfirm: [null],
      surveyFormSMS: [true],
      patientArrived: [null],
      patientNoArrivalReason: [""],
      noExamReason: [""],
      SmsConsent: [{ value: true, disabled: true }],
      examCode: [null],
    });

    if (this.ls.premissions?.PayerPricing) {
      this.appointmentForm.addControl("Payer", this.fb.control(null));
    }

    this.onExamTypeChange();

    // Recompute available exam codes when the payer/HMO changes
    this.fundingSub = this.appointmentForm
      .get("Funding")
      .valueChanges.subscribe(() => this.refreshExamCodes());
  }

  availableCodes: string[] = [];

  private getSelectedExamObj(): any {
    const id = this.appointmentForm.get("examTypeID").value;
    if (!id) return null;
    const list = this.appointmentForm.get("custom").value ? this.customExamTypes : this.examsTypes;
    return list.find((e) => e.AutoIndex == id) || null;
  }

  private resolveHmoKey(): string | null {
    const funding = this.appointmentForm.get("Funding").value;
    if (funding === "Private") return "Private";
    if (funding === "Hmo") {
      return this.patientService.currentPatient?.HMO || this.event?.HMO || null;
    }
    return null;
  }

  // Builds availableCodes for the selected exam + payer, auto-fills a single code.
  refreshExamCodes(): void {
    const exam = this.getSelectedExamObj();
    const hmoKey = this.resolveHmoKey();
    let codes: string[] = [];
    if (exam && hmoKey && exam[hmoKey + "Code"]) {
      codes = exam[hmoKey + "Code"]
        .toString()
        .split(",")
        .map((s: string) => s.trim())
        .filter(Boolean);
    }
    this.availableCodes = codes;
    const control = this.appointmentForm.get("examCode");
    const current = control.value;
    if (codes.length === 1) {
      control.setValue(codes[0], { emitEvent: false });
    } else if (codes.length === 0) {
      control.setValue(null, { emitEvent: false });
    } else if (!codes.includes(current)) {
      control.setValue(null, { emitEvent: false });
    }
  }

  onExamTypeChange(): void {
    this.examTypeSubscription = this.appointmentForm
      .get("examTypeID")
      .valueChanges.subscribe((selectedExam) => {
        if (selectedExam) {
          let exam;
          if (this.appointmentForm.get("custom").value) {
            exam = this.customExamTypes.find((exam) => {
              return exam.AutoIndex == selectedExam;
            });
          } else {
            exam = this.examsTypes.find((exam) => {
              return exam.AutoIndex == selectedExam;
            });
          }
          this.appointmentForm.get("duration").setValue(exam.Length, { emitEvent: false });
          this.timeSingleOrTwin = ""; // reset selection after exam change
          if (this.appointmentForm.get("Fetus").value == "2" && exam.LengthTwins) {
            this.appointmentForm.get("duration").setValue(exam.LengthTwins, { emitEvent: false });
          }
          this.appointmentForm.get("Price").setValue(null, { emitEvent: false });
        }
        this.refreshExamCodes();
      });
  }

  getEventTypeDuration(type: string) {
    const typeColorMapper = this.examsTypes;
    const exam = typeColorMapper.find((exam) => exam.examName === type);
    return exam ? exam.Length : null; /**default value is blue of calendar */
  }

  saveAppointment(answer?: boolean) {
    const creating = !this.event;
    const shouldAsk = creating && this.ls?.premissions?.ManualSMS && !this.isSmsDisabledByConsent;

    if (shouldAsk && answer === undefined) {
      if (this.smsDisabled) {
        answer = false;
      } else {
        this.askSendSMS = true;
        return;
      }
    }

    // if (!this.isObs()) this.appointmentForm.get("LMP")?.setValue(null);

    const pid = this.appointmentForm.get("PID")?.value ?? this.patientService.getPat()?.PID;

    const willSendAfterCreate = shouldAsk && answer === true && !this.isSmsDisabledByConsent;

    if (willSendAfterCreate) this.creatingPending = true;

    this.appointmentService.addEvent(this.appointmentForm.value).subscribe(
      (data) => {
        const newId = data?.["AutoIndex"];

        if (newId && willSendAfterCreate && pid) {
          const isUpdate = false;
          this.sendSMS(Number(newId), Number(pid), isUpdate, {
            onFinally: () => {
              //this.creatingPending = false
            },
          });
          return;
        }

        this.creatingPending = false;
        if (data?.["AutoIndex"]) {
          this.patientService.currentPatient = null;
          this.closeAppointmentModal("reloadEvents");
        }
      },
      (err) => {
        this.creatingPending = false;
        this.error = err?.error?.error || err?.message || "Failed to create appointment";
      }
    );
  }

  async deleteAppointment() {
    try {
      const result = await this.appointmentService.delete();
      if (result) {
        this.closeAppointmentModal("reloadEvents");
      }
    } catch (error) {
      console.error("Error during the deletion process:", error);
    }
  }

  async updateAppointment() {
    try {
      const ManualSMS = this.ls?.premissions?.ManualSMS;
      const appointmentData = { ...this.appointmentForm.value };

      // Check if LMP exists and set the time to 6:00 AM
      if (appointmentData.LMP) {
        const lmpDate = new Date(appointmentData.LMP);
        lmpDate.setHours(6, 0, 0, 0); // Set hours to 6:00 AM
        appointmentData.LMP = lmpDate;
      }
      const result = await this.appointmentService.updateAppointment(appointmentData);
      const noChanges = result["noChanges"];
      const ok = result["status"] === "ok";

      if (noChanges) {
        console.log("No Changes");
        this.errorUpdate = false;
        this.closeAppointmentModal("reloadEvents");
      }
      if (ok && !noChanges) {
        // here only if changes deteced and manualSmS is on then ask to send and update for sms
        if (ManualSMS) {
          this.sendUpdateSMS = true;
          this.askSendSMS = true;
          // this.startManualSms(isUpdate);
        } else {
          console.log("Changes deteced");
          this.errorUpdate = false;
          this.closeAppointmentModal("reloadEvents");
        }
      }
    } catch (error) {
      console.error("Error during the update Appointment:", error);
      // to do : display on screen error  update appointment
      this.errorUpdate = true;
    }
  }

  ngOnDestroy(): void {
    if (this.examTypeSubscription) {
      this.examTypeSubscription.unsubscribe();
    }
    if (this.fetusSub) {
      this.fetusSub.unsubscribe();
    }
    if (this.fundingSub) {
      this.fundingSub.unsubscribe();
    }
    if (this.appointmentDateSub) {
      this.appointmentDateSub.unsubscribe();
    }
    this.payerSub.unsubscribe();
    this.priceSub.unsubscribe();
    this.priceManualSub.unsubscribe();
  }

  toggleCheckbox(field: string) {
    this.appointmentForm.get(field).setValue(false);
  }

  reset(fname: string) {
    this.appointmentForm.get(fname).setValue(null);
  }

  lmpGA(lmp) {
    if (!lmp) return "";
    //remove the time component from lmp Date object in order to calculate GA from midnight
    let lmpDate = new Date(lmp);
    lmpDate.setHours(0, 0, 0, 0);
    let dt = new Date(this.appointmentForm.get("appointmentDate").value);
    let days = Math.floor((dt.getTime() - lmpDate.getTime()) / (1000 * 60 * 60 * 24));
    if (Math.floor(days / 7) < 1 || Math.floor(days / 7) > 50) return "";
    return Math.floor(days / 7) + "w " + (Math.floor(days) % 7) + "d";
  }

  isObs() {
    const examID = this.appointmentForm.get("examTypeID").value;
    if (!examID) return false;
    const exam = this.allAppointmentsType.find((exam) => {
      return exam.AutoIndex == examID;
    });
    return this.settings.categories["Pregnancy"].includes(exam.examType);
  }
  checklmp(lmp) {
    if (!lmp) return "";
    let dt = new Date(this.appointmentForm.get("appointmentDate").value);
    let days = Math.floor((dt.getTime() - Date.parse(lmp)) / (1000 * 60 * 60 * 24));
    if (Math.floor(days / 7) < 1 || Math.floor(days / 7) > 50) return "";
    const weeks = Math.floor(days / 7);
    const examID = this.appointmentForm.get("examTypeID").value;
    const exam = this.examsTypes.find((exam) => {
      return exam.AutoIndex == examID;
    });
    if (!exam.minWeeks || !exam.maxWeeks) return (this.lmpError = false);
    const validLmp = exam.minWeeks <= weeks && exam.maxWeeks >= weeks;
    this.lmpError = !validLmp;
  }

  calculateAppointmentPrice() {
    this.appointmentService.calcAppointmentPrice({ ...this.appointmentForm.value }).subscribe((data) => {
      if (data["price"]) {
        this.calculatedPrice = data["price"];
      }
    });
  }

  setPrice() {
    this.appointmentForm.get("Price").setValue(this.calculatedPrice);
    this.setExtraDetails = false;
    this.calculatedPrice = null;
  }

  getExamType() {
    const examID = this.appointmentForm.get("examTypeID").value;
    const exam = this.allAppointmentsType.find((exam) => {
      return exam.AutoIndex == examID;
    });
    return exam.examType;
  }

  getExam() {
    const examID = this.appointmentForm.get("examTypeID").value;
    const exam = this.allAppointmentsType.find((exam) => {
      return exam.AutoIndex == examID;
    });
    return exam;
  }

  goBillingsPatient(patient: any) {
    this.patientService.getPatient(patient.PID, () => {
      const target = "/billing";

      if (this.router.url === target) {
        // force reload by bouncing through a dummy route
        this.router
          .navigateByUrl("/appointments", { skipLocationChange: true })
          .then(() => this.router.navigate([target]));
      } else {
        this.router.navigate([target]);
      }
    });
  }

  goAppointmentsPatient(patient: any) {
    this.appointmentService.appointmentToNavBack = this.event;

    this.patientService.getPatient(patient.PID, () => {
      const id = this.patientService.currentPatient.PID;
      const target = `/appointments/patient/${id}`;

      if (this.router.url === target) {
        // force reload by bouncing through a dummy route
        this.router.navigateByUrl("/appointments", { skipLocationChange: true }).then(() => {
          this.router.navigate([target]).then((ok) => {
            if (ok) this.closed.emit();
          });
        });
      } else {
        this.router.navigateByUrl(target).then((ok) => {
          if (ok) this.closed.emit();
        });
      }
    });
  }

  addDeletedExam() {
    if (this.event.custom) {
      this.customExamTypes.push({ AutoIndex: this.event.examTypeID, examType: this.event.Type });
    } else {
      this.examsTypes.push({ AutoIndex: this.event.examTypeID, examType: this.event.Type });
    }
  }

  // async getHmoBalance(month = this.appointmentForm.get('appointmentDate').value, uid = this.appointmentForm.get('UID').value, hmo = this.patientService.currentPatient.HMO) {
  //   if (!hmo || !uid) return;
  //   try {
  //     const monthName = moment(month).locale('en').format('MMMM');
  //     const formattedMonth = moment(month).format('YYYY-MM');
  //     const data = await this.settings.getHMOQuotaByMonth(hmo, monthName,uid);
  //     if( data['quota']=== undefined) return this.hmoBalance=undefined
  //     const appointmentsCount = await this.settings.getAppointmentsCountPromise(hmo, formattedMonth,uid);
  //     const balance = data['quota'] - appointmentsCount['appointmentCount'];
  //     this.hmoBalance = balance;
  //   } catch (error) {
  //     this.hmoBalance = undefined;
  //   }
  // }
  // isHmoBalanceValidAndfinished(): boolean {
  //   return typeof this.hmoBalance === 'number' && this.hmoBalance < 1;
  // }

  // isHmoBalance(): boolean {
  //   return typeof this.hmoBalance === 'number'
  // }

  async saveInWaitingList() {
    const body = {
      UID: this.appointmentForm.get("UID").value,
      ID: this.appointmentForm.get("ID").value,
      First: this.patientService.getPat().First,
      Last: this.patientService.getPat().Last,
      Mobile: this.appointmentForm.get("patientMobile").value,
      LMP: this.appointmentForm.get("LMP").value,
      PID: this.appointmentForm.get("PID").value,
      HMO: this.patientService.currentPatient.HMO,
      ExamType: this.getExamType(),
      Message: this.appointmentForm.get("comment").value,
    };
    if (body.LMP) {
      const lmpDate = new Date(body.LMP);
      lmpDate.setHours(6, 0, 0, 0); // Set hours to 6:00 AM
      body.LMP = lmpDate;
    }

    await this.appointmentService.saveInWaitingList(body);
    this.patientService.currentPatient = null;
    this.closeAppointmentModal("reloadEvents");
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  selectColor(color: string) {
    this.selectedColor = color;
    this.dropdownOpen = false;
    this.appointmentForm.get("customColor")?.setValue(color);
  }

  findClosestAppointment() {
    const { appointmentDate } = this.appointmentForm.value;
    this.appointmentService
      .findClosestAppointment(appointmentDate, this.slotDuration)
      .subscribe((data: any) => {
        if (data.conflict) {
          this.appointmentForm.get("startHour").setValue(data.newAppointmentTime);
        }
      });
  }

  async getPatAppointments() {
    const appointments = await this.patientService.getAppointments(
      this.patientService.currentPatient.PID
    );
    this.previousAppointments = appointments["previous"];
    this.totalAppointments = this.previousAppointments.length;

    // Reset counters
    this.confirmedArrivals = 0;
    this.canceledArrivals = 0;
    this.noShowAfterConfirmation = 0;

    // Count confirmed, canceled, and no-show after confirmation
    this.previousAppointments.forEach((appointment) => {
      if (appointment.arrivalConfirm === true) {
        this.confirmedArrivals++;
        if (appointment.completed === false || appointment.completed === null) {
          this.noShowAfterConfirmation++;
        }
      } else if (appointment.arrivalConfirm === false) {
        this.canceledArrivals++;
      }
    });

    this.loadPreAppointmentsChanges();
  }

  loadPreAppointmentsChanges() {
    this.previousAppointments.forEach((appointment) => {
      this.getDateChangesCount(appointment, this.dateChangesCounts);
    });
  }

  getDateChangesCount(appointment, targetCounts: { [key: number]: number }) {
    const { AutoIndex, PID } = appointment;
    if (!AutoIndex || !PID) {
      console.warn("Missing AutoIndex or PID for appointment:", appointment);
      return;
    }

    this.http
      .get<number>(`api/appointment/countDateChanges?PID=${PID}&AppointmentId=${AutoIndex}`)
      .subscribe(
        (data: any) => {
          this.allChanges.push(data.changes);
          this.totalChanges += data.changes;
          targetCounts[AutoIndex] = data.changes;
        },
        (error) => {
          console.error(`Failed to load changes for appointment ${AutoIndex}`, error);
        }
      );
  }

  clearPatientArrived(event: MouseEvent) {
    event.stopPropagation(); // so the second click won't immediately re-toggle
    event.preventDefault();
    this.appointmentForm.get("patientArrived")?.setValue(null);
  }

  startManualSms() {
    if (this.smsDisabled || this.smsPending || this.isSmsDisabledByConsent) return;
    this.smsPending = true;
    const isUpdate = false;
    this.sendSMS(undefined, undefined, isUpdate, {
      onFinally: () => {
        this.smsPending = false;
      },
    });
  }

  isAppointmentIn1to2Days(): boolean {
    const dt = this.getAppointmentDateTime();
    if (!dt) return false;

    const now = new Date();
    const dayOfWeek = now.getDay(); // 0=Sun, 1=Mon, ..., 6=Sat

    // Saturday - don't allow sending (cron job skips Saturday)
    if (dayOfWeek === 6) return false;

    const diffMs = dt.getTime() - now.getTime();
    const diffDays = diffMs / (1000 * 60 * 60 * 24);

    // Allow manual sending for appointments from tomorrow up to 3 days away
    // Minimum: a few hours ahead (0.1 days ~2.4 hours)
    // Maximum: 3 days away (3.1 buffer)
    return diffDays >= 0.1 && diffDays <= 3.1;
  }

  sendScheduleReminder() {
    if (!this.isAppointmentIn1to2Days() || this.scheduleSmsPending || this.isSmsDisabledByConsent) return;

    this.scheduleSmsError = "";
    this.scheduleSmsSent = false;
    this.scheduleSmsPending = true;

    const autoIndex =
      this.appointmentForm.get("AutoIndex")?.value ??
      this.appointmentService.AutoIndex ??
      this.event?.AutoIndex;

    const pid =
      this.appointmentForm.get("PID")?.value ?? this.patientService.getPat()?.PID;

    if (!autoIndex || !pid) {
      this.scheduleSmsError = "Missing appointment or patient information";
      this.scheduleSmsPending = false;
      return;
    }

    // immediate: false sends reminder-style message with confirmation link
    const body = { PID: Number(pid), immediate: false };

    this.appointmentService.sendAppointmentSms(Number(autoIndex), body).subscribe(
      (res: any) => {
        this.scheduleSmsPending = false;
        this.scheduleSmsSent = true;
        this.scheduleSmsError = "";
        setTimeout(() => {
          this.scheduleSmsSent = false;
        }, 3000);
      },
      (err) => {
        this.scheduleSmsPending = false;
        this.scheduleSmsError = err?.error?.error || "Failed to send reminder SMS";
      }
    );
  }

  sendSMS(
    autoIndexOverride?: number,
    pidOverride?: number,
    isUpdate: boolean = false,
    opts?: { onFinally?: () => void }
  ) {
    if (this.smsDisabled) {
      opts?.onFinally?.();
      return;
    }

    this.error = "";

    const autoIndex =
      autoIndexOverride ??
      this.appointmentForm.get("AutoIndex")?.value ??
      this.appointmentService.AutoIndex ??
      this.event?.AutoIndex;

    const pid =
      pidOverride ?? this.appointmentForm.get("PID")?.value ?? this.patientService.getPat()?.PID;

    if (!autoIndex || !pid) {
      this.error = "Missing required IDs (AutoIndex / PID).";
      opts?.onFinally?.();
      return;
    }

    const body = { PID: Number(pid), immediate: true, update: isUpdate };

    this.appointmentService.sendAppointmentSms(Number(autoIndex), body).subscribe(
      (res: any) => {
        const ok = res?.ok === true || res?.status === "ok";
        if (!ok) {
          this.error = res?.error || "Failed to send SMS";
          opts?.onFinally?.();
          return;
        }
        this.sent = true;
        this.ls.linksent = (this.ls.linksent || 0) + 1;
        opts?.onFinally?.(); // clear pending before closing
        setTimeout(() => this.closed.emit(), 2000);
      },
      (err) => {
        this.error = err?.error?.error || err?.message || "Failed to send SMS";
        opts?.onFinally?.();
      }
    );
  }

  private updateSmsDisabled(): void {
    const dt = this.getAppointmentDateTime();
    if (!dt) {
      this.smsDisabled = false;
      return;
    }
    const GRACE_MIN = 5;
    this.smsDisabled = dt.getTime() < Date.now() - GRACE_MIN * 60_000;
  }

  private getAppointmentDateTime(): Date | null {
    // 1) try form values
    const rawDate = this.appointmentForm?.get("appointmentDate")?.value;
    const timeStr = this.appointmentForm?.get("startHour")?.value as string;

    if (rawDate && timeStr) {
      const base = new Date(rawDate);
      const [hh, mm] = (timeStr || "00:00").split(":").map((v) => Number(v));
      if (!isNaN(base.getTime()) && !isNaN(hh) && !isNaN(mm)) {
        base.setHours(hh, mm, 0, 0);
        return base;
      }
    }

    // 2) fallback to event.aptTime if present
    if (this.event?.aptTime) {
      const fromEvent = new Date(this.event.aptTime);
      if (!isNaN(fromEvent.getTime())) return fromEvent;
    }

    return null;
  }

  getApptLength(event) {
    this.showApptLengthError = false;
    const durationControl = this.appointmentForm.get("duration");
    const exam = this.getExam();

    if (event === "twins") {
      if (!exam.LengthTwins) {
        this.showApptLengthError = true;
        this.apptLengthErrorMsg = this.translate.instant(
          `appointments.gui.labels.duration for twins wasn't defined`
        );
      }

      durationControl.setValue(exam.LengthTwins);
    } else {
      // event === 'single'
      if (!exam.Length) {
        this.showApptLengthError = true;
        this.apptLengthErrorMsg = this.translate.instant(
          `appointments.gui.labels.duration for singleton wasn't defined`
        );
      }
      durationControl.setValue(exam.Length);
    }
  }

  get isExamMissing(): boolean {
    return !this.appointmentForm.get("examTypeID").value;
  }

  get isSmsDisabledByConsent(): boolean {
    const consent = this.appointmentForm.get("SmsConsent")?.value;
    return consent === false;
  }
}
